import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Blogs = () => {
    return (
        <div id="blogs" className="container">
            <div className="title">
                <h2 className="my-4"> <span className="title-color">Some of</span>  my Blogs</h2 >
                <hr className="w-25" />
                <div style={{ marginLeft: '-30px' }}>
                    <Link to="/home#blogs">
                        <Button variant="outline-success">Blogs</Button>{' '}
                    </Link>
                </div>
            </div>
            <div data-aos="zoom-in">
                <h2>Coming soon</h2>

            </div>
        </div>
    );
};

export default Blogs;